import React, { useEffect, useState } from "react";
import { Route, Router, Switch } from "react-router-dom";
import "./App.css";
import PrivateRoute from "./components/Auth/PrivateRoute";
import { useAuth } from "./components/Auth/useAuth";
import ConfigurationLoader from "./components/Configuration/configurationLoader";
import Footer from "./components/Footer/Footer";
import TranslationsLoader from "./components/Translations/TranslationsLoader";
import "./helpers";
import history from "./history";
import NotFound from "./pages/NotFound";
import combinedRoutes from "./routes";
import Snackbar from "./components/Snackbar/Snackbar";
import OperatorHeader from "./components/Headers/OperatorHeader/operatorHeader";

const generateRoutes = (routes) =>
  routes.map((route, key) =>
    route.private === false ? (
      <Route key={key} {...route} />
    ) : (
      <PrivateRoute key={key} {...route} />
    ),
  );

function App() {
  const [{ user }] = useAuth();

  // (user && user.data.lang) ||
  // window.navigator.language ||
  // navigator.language.language ||
  // navigator.userLanguage.language ||
  const [lang, updateLanguage] = useState("fr");

  // useEffect(() => {
  //   if (user && user.data && user.data.lang && user.data.lang !== lang) {
  //     updateLanguage(user.data.lang);
  //   }
  // }, [user]);

  const appVer = "V 1.1.6";

  return (
    <React.Fragment>
      <div className="app-container">
        <div className="app-content">
          <Router history={history}>
            <OperatorHeader />
            <Switch>
              {generateRoutes(combinedRoutes)}
              <Route component={NotFound} />
            </Switch>
            <TranslationsLoader lang={lang} userId={user?.client_profile?.id} />
            <ConfigurationLoader />
          </Router>
        </div>
        <div className="footer-locator">
          <Footer
            appVersion={appVer}
            handleLanguageChange={(el) => updateLanguage(el)}
            currentLanguage={lang}
          />
          <Snackbar />
        </div>
      </div>
    </React.Fragment>
  );
}

export default App;
